import * as apiValues from '../constants/apiValues';
import * as projectTypeListActions from '../actions/projectTypeListActions';
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from '../withRouterCompat';


class ProjectTypeList extends React.Component{
  filter = '';


  componentDidMount(){
    //console.log(`ProjectTypeList.componentDidMount()`, this.props);

    let defaultValue = this.props.defaultValue ? this.props.defaultValue.split(',') : null;
    this.props.actions.initProjectTypeList(
      this.props.navListId,
      defaultValue,
      this.props.cmsName,
    );
  }


  projectType_onClick = filter => {
    // console.log(`projectType_onClick`, filter);
    this.props.onFilter(filter);
  };


  isTypeSelected(typeId){
    const selected = this.props.projectTypeList.selectedProjectTypes;
    if(!selected || selected.length < 1) return true;
    return selected.indexOf(typeId) >= 0;
  }
  renderProjectTypeIcon(type) {
    const iconUrl = type.icon && type.icon.url;
    if (!iconUrl) return null;
    return (
      <img
        alt=""
        className="project-type-list__project-type-icon"
        src={apiValues.imgPath(iconUrl)}
      />
    );
  }
  renderProjectTypes(){
    return this.props.projectTypeList.types.map(type => {
      let activeClass = this.isTypeSelected(type.id) ? 'project-type-list__project-type--is-active' : '';

      if(this.props.onFilter) return (
        <li key={type.id}>
          <button type="button"
                  className={`project-type-list__project-type ${activeClass}`}
                  aria-label={type.title}
                  onClick={() => {
                    this.projectType_onClick(type.id);
                  }}>
            {this.renderProjectTypeIcon(type)}
            <span className="project-type-list__project-type-title">{type.title}</span>
          </button>
        </li>
      );
      else return (
        <li key={type.id}>
          <a href={type.url}
             className={`project-type-list__project-type ${activeClass}`}>
            {this.renderProjectTypeIcon(type)}
            <span className="project-type-list__project-type-title">{type.title}</span>
          </a>
        </li>
      );
    });
  }
  render(){
    //console.log(`ProjectTypeList.render()`, this, this.props.projectTypeList.types);
    if(!this.props.projectTypeList || !this.props.projectTypeList.types) return null;

    return (
      <ul role="list" className={`project-type-list ${this.props.className || ''}`}>
        {this.renderProjectTypes()}
      </ul>
    );
  }
}


export default withRouter(connect(
  (state) => ({
    projectTypeList: state.projectTypeList
  }),
  (dispatch) => ({
    actions: bindActionCreators(projectTypeListActions, dispatch)
  })
)(ProjectTypeList));


ProjectTypeList.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsName: PropTypes.string,
  navListId: PropTypes.string,
  onFilter: PropTypes.func,
  projectTypeList: PropTypes.object.isRequired,
  defaultValue: PropTypes.string,
};
